import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { GoodsReceiptNote, GoodsReceiptNoteCreate, GoodsReceiptNoteFilter } from '../data/goodsReceiptNote';

export function createGoodsReceiptNoteService(client: AxiosInstance) {
  return createCrudService<GoodsReceiptNote, GoodsReceiptNoteCreate, GoodsReceiptNoteFilter>(
    client,
    '/purchase/GoodsReceiptNote',
    'id',
  );
}

export type GoodsReceiptNoteService = CrudService<GoodsReceiptNote, GoodsReceiptNoteCreate, GoodsReceiptNoteFilter>;
